<div class="rx-card read-only read-only-container" [class.read-only-container--intuitive]="isIntuitiveFlow" id="patient-app-read-only">
	<div class="rx-card-title">
		<div class="rx-title-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between rx-app-flex-container-row--align-center">
			<div *ngIf="!isIntuitiveFlow">{{ 'PatientSection.Patient' | translate }}:</div>
			<div *ngIf="isButtonsVisible" class="clickable">
				<button
					*ngIf="isEditButtonVisible"
					tlkButton
					variant="primary"
					size="s"
					[disabled]="!patient"
					(click)="editPatient()"
					class="edit-button-margin"
					id="patient-read-only-edit-button"
				>
					<tlk-edit-icon></tlk-edit-icon>
				</button>
				<button
					*ngIf="isClearButtonVisible"
					tlkButton
					variant="primary"
					size="s"
					[disabled]="!patient"
					(click)="clearPatient()"
					class="clear-button-margin"
					id="patient-read-only-clear-button"
				>
					{{ 'PatientSection.Clear' | translate }}
				</button>
			</div>
		</div>
	</div>
	<div class="rx-card-body read-only">
		<form [formGroup]="formGroup">
			<div class="rx-card-body-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between">
				<rx-text-input class="rx-app-flex--half"
					[id]="'patient-read-only-first-name'"
					[label]="('PatientSection.FirstName' | translate) + ':'"
					[formControl]="firstNameControl"
					[isDisabled]="true"
				></rx-text-input>

				<rx-text-input class="rx-app-flex--half"
					[id]="'patient-read-only-last-name'"
					[label]="('PatientSection.LastName' | translate) + ':'"
					[formControl]="lastNameControl"
					[isDisabled]="true"
				></rx-text-input>
			</div>

			<div class="rx-card-body-row rx-card-body-row--reverse rx-app-flex-container-row rx-app-flex-container-row--justify-space-between">
				<rx-text-input class="rx-app-flex--half"
					[id]="'patient-read-only-date-of-birth'"
					[label]="('PatientSection.DateOfBirth' | translate) + ':'"
					[formControl]="dateOfBirthControl"
					[isDisabled]="true"
				></rx-text-input>
				<div class="gender-container">
					<div class="group-container">
						<label class="label-gender">
							{{ (isIntuitiveFlow ? 'IntuitivePatient.GenderAtBirth' : 'PatientSection.Gender') | translate }}:
						</label>
						<tlk-radio-group
							[disabled]="true"
							name="patientGender"
							class="read-only group-container__radio-group"
						>
							<tlk-radio-button
								class="gender-option"
								[checked]="genderOption === 0"
								value="0"
								[label]="'PatientSection.Male' | translate"
							></tlk-radio-button>
							<tlk-radio-button
								class="gender-option"
								[checked]="genderOption === 1"
								value="1"
								[label]="'PatientSection.Female' | translate"
							></tlk-radio-button>
						</tlk-radio-group>
					</div>
					<div class="underline"></div>
				</div>
			</div>

			<div class="rx-card-body-row rx-app-flex-container-row rx-app-flex-container-row--justify-space-between">
				<rx-text-input class="rx-app-flex--half"
					[id]="'patient-read-only-chart-number'"
					[label]="('PatientSection.ChartNumber' | translate) + ':'"
					[formControl]="chartNumberControl"
					[isDisabled]="true"
				></rx-text-input>
			</div>
		</form>
	</div>
</div>
